import { getRewardDescription } from '../../utils/rewardCopy';
import TemplateRewardLink from './TemplateRewardLink';

// What a teacher earned, as one standalone sentence plus a CTA for the reward types that
// need one. Used by the referrer-side surfaces — the onboarding wizard's claim step and
// ShareReferralModal — which render it as body copy inside their own card, with no title
// above it naming the reward.
//
// The referee modal does NOT use this: it names the benefit in its own title and completes
// the sentence underneath, so it takes the title/subtitle pair from getRefereeRewardCopy
// instead. Both wordings live in utils/rewardCopy so they can't drift apart.
//
// `trialEndDateIso` turns "you have 30 free days" into "you have Premium until <date>", and
// is only correct if the caller's user object already reflects this grant. Nobody passes it
// today: these surfaces render right after their own grant lands, while their cached user is
// still pre-grant, so they'd state a date short by the amount just awarded.
export default function ReferralRewardDetail({ reward, trialEndDateIso = null }) {
  if (!reward) return null;
  const { reward_type: rewardType, amount, payload } = reward;

  // Optional chaining throughout: in the wizard isClaimableReward gated these, but a grant
  // with an empty reward_json would otherwise throw and take the whole app down.
  const description = getRewardDescription({ rewardType, amount, payload, trialEndDateIso });
  if (!description) return null;

  return (
    <div className='text-center text-gray-700'>
      <p>{description}</p>
      {rewardType === 'template' && <TemplateRewardLink reward={reward} />}
    </div>
  );
}
